export const supportedKeySystems = ['com.apple.fps.1_0', 'com.apple.fps.2_0'];
